import React from 'react';
import './Style/PrivacyPolicy.css';
import TopNavbar from './/../home/TopNavbar';

const PrivacyPolicy = () => {
  const lastUpdated = "August 2026";
  const contactEmail2 = "sarwar93390@gmail.com";
  const contactEmail1 = 'contact@mystudyplace.online';

  return (
    <div className="privacy-container">
      <div className="privacy-card">
        <TopNavbar name="Privacy Policy" />

        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: {lastUpdated}</p>

        {/* --- MANDATORY GOOGLE COMPLIANCE SECTION --- */}
        <section style={{ border: '1px solid #ddd', padding: '15px', borderRadius: '8px', marginBottom: '20px', backgroundColor: '#f9f9f9' }}>
          <h2 style={{ color: '#d9534f', fontSize: '16px' }}>Government Disclaimer</h2>
          <p>
            <strong>NEET Prep</strong> is an independent educational app. We are <strong>not affiliated with</strong>, authorized by, or endorsed by the <strong>National Testing Agency (NTA)</strong> or any government body.
          </p>
          <p>
            The government-related information, exam patterns, and syllabus provided in this app are for educational purposes and are sourced from the official NTA website:
            <a href="https://nta.ac.in/" target="_blank" rel="noreferrer" style={{ marginLeft: '5px', wordBreak: 'break-all' }}>
              https://nta.ac.in/
            </a>
          </p>
        </section>
        {/* ------------------------------------------ */}

        <section>
          <h2>1. Introduction</h2>
          <p>
            Welcome to <strong>NEET Prep</strong>. We value your privacy and are committed
            to providing a secure environment for your exam preparation. This Privacy Policy
            explains how we handle information within our mobile application when you use our platform.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect (Optional Registration)</h2>
          <p>
            You can use many features of our app as a guest—such as browsing questions and answers—without creating an account. However, to <strong>submit your own doubts</strong>, access premium content, before payment, or sync your progress across multiple devices, you must create an account. During registration, we collect the following personal information:
          </p>
          <ul>
            <li><strong>Name:</strong> To personalize your user profile dashboard.</li>
            <li><strong>Class/Academic Stream:</strong> To display target mock tests specific to your educational tier.</li>
            <li><strong>Phone Number:</strong> To send important study notifications, updates, and exam alerts directly to you.</li>
            <li><strong>Email Address:</strong> For account authentication, secure OTP verification, and login management.</li>
          </ul>
        </section>

        <section>
          <h2>3. Data Retention and Account Deletion (Google Play Compliance)</h2>
          <p>
            We retain your data only for as long as your account remains active. We strongly respect your right to control your personal details.
          </p>
          <p>
            <strong>How to Delete Your Data:</strong> You can request complete deletion of your account and associated personal data at any time directly inside the app by using the <strong>"Delete Account"</strong> button in your Profile section.
          </p>
          <p>
            Alternatively, you can submit an online account deletion request via email at <a href={`mailto:${contactEmail1}`}>{contactEmail1}</a> or visit our official deletion portal at <a href="https://neetmocktest.mystudyplace.in/account-delete" target="_blank" rel="noreferrer">neetmocktest.mystudyplace.in/delete-account</a>.
          </p>
          <p>
            Once requested, the deletion process is executed <strong>immediately</strong>. All of your profile information—including registered name, email address, phone number, academic stream, and test attempt history—will be permanently erased from our backend database.
          </p>
        </section>

        <section>
          <h2>4. Local Storage of Test Data</h2>
          <p>
            For guest profiles, your mock test data, including <strong>scores, percentages, and progress reports</strong>, are stored exclusively on your device's <strong>Local Storage</strong>.
          </p>
        </section>

        <section>
          <h2>5. In-App Purchases, Google Play Billing & Refund Policy</h2>
          <p>
            When you purchase premium study packages, mock test subscriptions, or digital items within the app, all financial transactions are processed securely through <strong>Google Play Billing</strong>.
          </p>
          <p>
            We <strong>do not</strong> collect, store, or process your credit card numbers, debit card details, UPI IDs, or banking passwords on our servers. Google securely processes all payment data in accordance with its own privacy policy.
          </p>
          <p>
            <strong>Refund Policy:</strong> All active digital subscriptions and in-app purchases are final and non-refundable once unlocked. If a payment is deducted but access fails to unlock, Google Play or your bank will automatically process a refund within 3–5 business days.
          </p>
        </section>

        <section>
          <h2>6. Third-Party Services</h2>
          <p>
            We do not sell, rent, or trade your personal identifying data with third parties. If our app displays advertisements via third-party services (like Google AdMob), those services may utilize non-personal mobile advertising identifiers to present appropriate ads, governed by their own independent privacy terms.
          </p>
        </section>

        <section>
          <h2>7. Children’s Privacy</h2>
          <p>
            Our application is intended for students systematically preparing for competitive exams. We encourage parents and guardians to supervise active mobile registrations and authorize any digital purchases. We do not knowingly capture or process information from students under the age of 13 without appropriate parental awareness.
          </p>
        </section>

        <section>
          <h2>8. Changes to This Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any structural updates by revising the "Last Updated" timestamp featured at the top of this privacy portal page.
          </p>
        </section>

        <section className="contact-section">
          <h2>9. Contact Us</h2>
          <p>If you have any questions or require manual assistance removing your profile records, please reach out to us at:</p>
          Email: <a href={`mailto:${contactEmail1}`} className="email-button">
            {contactEmail1}
          </a> <br />
          Gmail: <a href={`mailto:${contactEmail2}`} className="email-button">
            {contactEmail2}
          </a> <br /><br />
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;